import { render, staticRenderFns } from "./WNavBar.vue?vue&type=template&id=37759ca6&scoped=true&"
import script from "./WNavBar.vue?vue&type=script&lang=js&"
export * from "./WNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37759ca6",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WLogoOrsai from '@/components/WLogoOrsai.vue'
import WMenuItems from '@/components/WMenuItems.vue'
autoInstallComponents(component, {WLogoOrsai,WMenuItems})
